/**
 * RBAC Module Constants
 * Source: rbac_modules table
 * Synced with backend: basiq360_product_backend/src/constants/modules.constants.ts
 */

export const MODULE_ID = {
  DROPDOWN_MANAGEMENT: 13,
  ANALYTICS: 100,
  PRIMARY_CUSTOMER: 102,
  PRODUCT_MASTER: 104,
  SALES_USER: 105,
  ROLE: 106,
  SECONDARY_CUSTOMER: 109,
  PRODUCT_PRICE: 111,
  BACKEND_USER: 112,
  PERMISSION: 113,
  IRP_ANALYTICS: 114,
  SITES: 115,
  DIRECT_NETWORK: 116,
  TERTIARY_ORDER: 117,
  PRODUCT_DISCOUNT: 118,
  // PRODUCT_VARIANT: 148, // Deprecated - Variants removed from system
  CUSTOMER_NETWORK: 119,
  INFLUENCER_CUSTOMER: 120,
  ORDERS: 122,
  QUOTATION: 123,
  ACCOUNTS: 124,
  MAP: 126,
  ACTIVITY: 127,
  EVENT_PLAN: 132,
  POP_GIFT: 133,
  SURVEY: 134,
  SUPPORT: 136,
  TARGET: 137,
  PRODUCT: 138,
  USER: 139,
  ROLE_PERMISSION: 140,
  SESSION_MANAGEMENT: 141,
  HOLIDAY: 142,
  CHAT: 143,
  REPORT: 144,
  APP_CONFIG: 145,
  POSTAL: 146,
  KEYBOARD_SHORTCUT: 147,
  ENQUIRY: 149,
  // Kodia field-role sidebar tiles (view-only Customer Networks). Backend seeds
  // via sql-backfills-2026-07-04/20-kodia-role-network-modules.sql.
  KODIA_DEALER_NETWORK: 230,
  KODIA_ARCHITECT_NETWORK: 231,
  KODIA_CUSTOMER_NETWORK: 232,
  // JBN field-role sidebar tiles. Backend seeds via
  // sql-backfills-2026-07-23/60-jbn-sidebar-modules.sql.
  JBN_INTERIOR_DESIGNER_NETWORK: 240,
  JBN_CONTRACTOR_NETWORK: 241,
} as const;

export const MODULE_NAMES: Record<number, string> = {
  13: 'Dropdown Management',
  100: 'Analytics',
  102: 'Primary Customer',
  104: 'Product',
  105: 'Sales',
  106: 'Role',
  109: 'Secondary Customer',
  111: 'Product Price',
  112: 'Backend',
  113: 'Permission',
  114: 'Influencer Reward Program',
  115: 'Sites',
  116: 'Direct Network',
  117: 'Tertiary',
  118: 'Product Discount',
  // 148: 'Product Variant', // Deprecated - Variants removed from system
  119: 'Customer Network',
  120: 'Influencer Customer',
  // 121: 'End Customer', // Soft deleted - no longer in use
  122: 'Orders',
  123: 'Quotation',
  124: 'Accounts',
  126: 'Map',
  127: 'Activity',
  132: 'Event Plan',
  133: 'Pop-Gift',
  134: 'Survey',
  136: 'Support',
  137: 'Target',
  138: 'Product',
  139: 'User',
  140: 'Role-Permission',
  141: 'Session Management',
  142: 'Holiday',
  143: 'Chat',
  144: 'Report',
  145: 'App Config',
  146: 'Postal',
  147: 'Keyboard Shortcut',
  149: 'Enquiry',
  230: 'Dealer Network',
  231: 'Architect Network',
  232: 'Customer Network',
  240: 'Interior Designer Network',
  241: 'Contractor Network',
};

export const MODULE_CODES: Record<number, string> = {
  13: 'DROPDOWN_MANAGEMENT',
  100: 'ANALYTICS',
  102: 'PRIMARY_CUSTOMER',
  104: 'PRODUCT_MASTER',
  105: 'SALES_USER',
  106: 'ROLE',
  109: 'SECONDARY_CUSTOMER',
  111: 'PRODUCT_PRICE',
  112: 'BACKEND_USER',
  113: 'PERMISSION',
  114: 'IRP_ANALYTICS',
  115: 'SITES',
  116: 'DIRECT_NETWORK',
  117: 'TERTIARY_ORDER',
  118: 'PRODUCT_DISCOUNT',
  // 148: 'PRODUCT_VARIANT', // Deprecated - Variants removed from system
  119: 'CUSTOMER_NETWORK',
  120: 'INFLUENCER_CUSTOMER',
  122: 'ORDERS',
  123: 'QUOTATION',
  124: 'ACCOUNTS',
  126: 'MAP',
  127: 'ACTIVITY',
  132: 'EVENT_PLAN',
  133: 'POP_GIFT',
  134: 'SURVEY',
  136: 'SUPPORT',
  137: 'TARGET',
  138: 'PRODUCT',
  139: 'USER',
  140: 'ROLE_PERMISSION',
  141: 'SESSION_MANAGEMENT',
  142: 'HOLIDAY',
  143: 'CHAT',
  144: 'REPORT',
  145: 'APP_CONFIG',
  146: 'POSTAL',
  147: 'KEYBOARD_SHORTCUT',
  149: 'ENQUIRY',
  230: 'KODIA_DEALER_NETWORK',
  231: 'KODIA_ARCHITECT_NETWORK',
  232: 'KODIA_CUSTOMER_NETWORK',
  240: 'JBN_INTERIOR_DESIGNER_NETWORK',
  241: 'JBN_CONTRACTOR_NETWORK',
};

// Type for Module ID values
export type ModuleIdValue = typeof MODULE_ID[keyof typeof MODULE_ID];
